
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?871ffbb70730ad3729f8108d4ec0fb53";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();




// WEBPACK FOOTER //
// ./src/assets/js/buriedPoint.js